document.documentElement.style.scrollBehavior = 'smooth';
document.addEventListener('click', (e) => {
  const anchor = e.target.closest('[data-anchor]');
  if (anchor) {
    e.preventDefault();
    const id = anchor.dataset.anchor;
    const dest = document.getElementById(id);
    if (!dest) return;
    const top = dest.getBoundingClientRect().top + window.pageYOffset - 100;
    window.scrollTo({ top, behavior: 'smooth' });
    return;
  }

  const btn = e.target.closest('.faq-question');
  if (btn) {
    const item   = btn.closest('.faq-item');
    const answer = item.querySelector('.faq-answer');
    const icon   = btn.querySelector('.vertical-line');
    const opening = answer.classList.contains('max-h-0');
    answer.classList.toggle('max-h-0',   !opening);
    answer.classList.toggle('max-h-auto', opening);
    icon.classList.toggle('opacity-0', opening);
  }
});

document.addEventListener('keydown', (e) => {
  if (e.key === 'Enter') {
    const anchor = e.target.closest('[data-anchor]');
    if (anchor) return anchor.click();
    const qbtn = e.target.closest('.faq-question');
    if (qbtn) return qbtn.click();
  }
});
